import { NgModule } from '@angular/core';

import { RadioModule } from 'app/main/elements/radio/radio.module';
import { DateTimePickerModule } from 'app/main/elements/date-time-picker/date-time-picker.module';
import { QuillModule } from 'ngx-quill';
@NgModule({
  declarations: [],
  imports: [
    RadioModule,
    DateTimePickerModule,
    QuillModule
  ],
  providers: [],
  exports: []
})
export class ElementsModule { }
